import { Module, MutationTree, ActionTree, GetterTree } from 'vuex'
import { RootState } from '@/types/store/index'
import { ContactState } from '@/types/store/contact'
import { axios } from '@/plugins/axios'

const initialValues: ContactState = {
  category: undefined,
  faqCategories: undefined
}

const state = (): ContactState => (initialValues)

const getters: GetterTree<ContactState, RootState> = {}

const mutations: MutationTree<ContactState> = {
  setCategory (state, category) {
    state.category = category
  },
  setFaqCategories (state, faqCategories) {
    state.faqCategories = faqCategories
  }
}

const actions: ActionTree<ContactState, RootState> = {
  fetchCategory: async ({ state, commit }) =>{
    if (! state.category) {
      const response = await axios.get('/contact/category')
      commit('setCategory', response.data.payload)
    }
  },
  fetchFaqCategories: async ({ state, commit }) =>{
    if (! state.faqCategories) {
      const response = await axios.get('/contact/faq')
      commit('setFaqCategories', response.data.payload)
    }
  },
}

export const contact: Module<ContactState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
